import type { Verse } from '@quranjs/api';
import type { Dictionary } from 'lodash';
import { createContext, useContext } from 'react';

const initialState: {
  versesByChapter: Dictionary<Verse[]>;
  pageId: string;
} = {
  versesByChapter: {},
  pageId: '',
} as const;

export type PageReaderContextType = typeof initialState;

const PageReaderContext = createContext<PageReaderContextType>(initialState);

export const usePageReaderContext = () => {
  const context = useContext(PageReaderContext);
  if (context === undefined) {
    throw new Error(
      'usePageReaderContext must be used within a PageReaderContextProvider.',
    );
  }

  return context;
};

export const PageReaderContextProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: PageReaderContextType;
}) => {
  return (
    <PageReaderContext.Provider value={value}>
      {children}
    </PageReaderContext.Provider>
  );
};
